import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const InputMonth = ({
  className = '',
  preText = '',
  postText = '',
  isRequired = false,
  isDisabled = false,
  value = '',
  min = '',
  max = '',
  step = 1,
  error = null,
  onChange,
  onBlur = () => {},
}) => {
  return (
    <div className={`input_text ${className}`}>
      {preText && (
        <div className={`pre_text ${error ? 'text_error' : ''}`}>
          {preText}
          {isRequired && <span className='is_required'>*</span>}
        </div>
      )}
      <input
        className={`input ${error ? 'input_error' : ''}`}
        type='month'
        disabled={isDisabled}
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => onChange(e.target.value)}
        onBlur={() => onBlur(value)}
      />
      {postText && <div className='post_text' dangerouslySetInnerHTML={{ __html: postText }} />}
    </div>
  );
};

InputMonth.propTypes = {
  className: PropTypes.string,
  preText: PropTypes.string,
  postText: PropTypes.string,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.object,
};

export default InputMonth;
